// @flow
import { createAction } from 'redux-action';

export const SELECT_PRODUCT = 'marketplace/recommended/select-product';

export const selectProduct = createAction(SELECT_PRODUCT);
